import { render } from "./FilterItem.vue?vue&type=template&id=36f8ace1"
import script from "./FilterItem.vue?vue&type=script&lang=js"
export * from "./FilterItem.vue?vue&type=script&lang=js"

import "./FilterItem.vue?vue&type=style&index=0&id=36f8ace1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__